export default __webpack_public_path__ + "static/media/program-banner-en.77433b1f.jpg";